import React, { useState } from "react"
import Modal from "./modal"
import { usePageMessageBrokerListener } from "./use_page_message_broker_listener";

export default function SourceAttributionIconButton({url}) {
  const [show, setShow] = useState(false)
  const [pageObjectChanged, setPageObjectChanged] = useState(false)

  const handleClose = () => {
    setShow(false)
    if (pageObjectChanged) {
      window.location.reload()
    }
  }

  usePageMessageBrokerListener('fieldValueSaved', (data) => {
    if (show && url) {
      setPageObjectChanged(true)
    }
  });

  return (
    <>
      <button 
        onClick={() => setShow(true)} 
        className="mt-[0.15rem] inline-flex items-center justify-center w-6 h-6 opacity-0 group-hover:opacity-100 transition-opacity duration-200 rounded cursor-pointer"
        title="View source"
      >
        <svg className="w-4 h-4 text-highlight-300 hover:text-highlight-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" strokeWidth="2"/>
          <text x="12" y="16" textAnchor="middle" className="text-lg font-medium" fill="currentColor">S</text>
        </svg>
      </button>

      <Modal
        open={show}
        onClose={handleClose}
        url={url}
      />
    </>
  )
}
